export const paymentTypeFilterLabel = Object.freeze({
  DEBIT_CARD: 'Cartão Débito/Crédito',
  CREDIT_CARD: 'Cartão Débito/Crédito',
  CASH: 'Dinheiro',
  ONLINE_PAYMENT: 'Pag online - Crédito',
  PIX: 'Pag online - PIX',
  NUPAY: 'Pag online - Nubank',
})

export const paymentTypeLabel = Object.freeze({
  DEBIT_CARD: 'Cartão Débito/Crédito',
  CREDIT_CARD: 'Cartão Débito/Crédito',
  CASH: 'Dinheiro',
  ONLINE_PAYMENT: 'Pag online - Crédito',
  PIX: 'Pag online - PIX',
  NUPAY: 'Pag online - Nubank',
})

export const paymentTypeEnum = Object.freeze({
  DEBIT_CARD: 'DEBIT_CARD',
  CREDIT_CARD: 'CREDIT_CARD',
  CASH: 'CASH',
  ONLINE_PAYMENT: 'ONLINE_PAYMENT',
  PIX: 'PIX',
  NUPAY: 'NUPAY',
})

export enum PaymentType {
  DEBIT_CARD = 'DEBIT_CARD',
  CREDIT_CARD = 'CREDIT_CARD',
  CASH = 'CASH',
  ONLINE_PAYMENT = 'ONLINE_PAYMENT',
  PIX = 'PIX',
  NUPAY = 'NUPAY',
}

export default Object.freeze({
  CREDIT_CARD: 'CREDIT_CARD',
  CASH: 'CASH',
  ONLINE_PAYMENT: 'ONLINE_PAYMENT',
  PIX: 'PIX',
})
